/* Copyright 2016-2022
   Kabandy
   Author: Jonathan Boosten
 */

import { ITime, ITimeSerialized } from ".";

export module UserDataModel {
    export enum EErrorMsg {
        Create = "Can't create user",
        Invite = "Can't invite user"
    }

    export enum ECreateErrorMsg {
        ContractNotFound = "Contract not found"
    }

    export interface IGenericUser {
        id: string;
        email: string;
        content?: any;
        time: ITime | ITimeSerialized;
    }

    export interface IUser extends IGenericUser {
        time: ITime;
    }

    export interface IUserSerialized extends IGenericUser {
        time: ITimeSerialized;
    }

    export interface IUserMetadata {
        uid: string;
        creationTime: string;
        lastSignInTime: string;
        lastRefreshTime: string;
    }
}
